import { FC } from 'react';
import { DrivingScoreList } from './DrivingScoreList';

type DrivingScoreListPageProps = {};

export const DrivingScoreListPage: FC<DrivingScoreListPageProps> = () => {
  return <DrivingScoreList />;
};
